/**
 * Organisation "Edit this page" link
 *
 * Shows edit links on any page for users who can manage the organisation.
 * Uses AJAX so the feature works correctly with full-page caching.
 *
 * Usage: add a hidden element anywhere with the class and data attributes:
 *
 *   <div class="js-org-edit-link" style="display:none"
 *        data-org-id="123"
 *        data-ajax-url="/wp-admin/admin-ajax.php">
 *     <a href="#">Edit this page</a>
 *   </div>
 *
 * The script will check each unique org ID once, then reveal all matching
 * links on the page.
 */
(function () {
	var links = document.querySelectorAll('.js-org-edit-link');
	if (!links.length) return;

	// Group elements by org ID to avoid duplicate AJAX calls
	var byOrg = {};
	links.forEach(function (el) {
		var orgId = el.getAttribute('data-org-id');
		var ajaxUrl = el.getAttribute('data-ajax-url');
		if (!orgId || !ajaxUrl) return;

		if (!byOrg[orgId]) {
			byOrg[orgId] = { ajaxUrl: ajaxUrl, elements: [] };
		}
		byOrg[orgId].elements.push(el);
	});

	// One request per unique org ID
	Object.keys(byOrg).forEach(function (orgId) {
		var group = byOrg[orgId];
		var data = new FormData();
		data.append('action', 'cee_can_edit_organisation');
		data.append('org_id', orgId);

		fetch(group.ajaxUrl, {
			method: 'POST',
			credentials: 'same-origin',
			body: data,
		})
			.then(function (r) {
				return r.json();
			})
			.then(function (res) {
				if (res.success && res.data.can_edit) {
					group.elements.forEach(function (el) {
						var link = el;
						if (link) {
							link.href = res.data.edit_url;
						}
						el.style.display = '';
					});
				}
			})
			.catch(function () {
				// Silently fail — links stay hidden
			});
	});
})();
